// src/shared/api/attachments.ts
import { $api } from "shared/api";

export const getAttachmentUrl = (attachmentId: string) =>
    `/ecpp/attachments/files?attachmentId=${encodeURIComponent(attachmentId)}`;

export const downloadAttachment = async (attachmentId: string) => {
    try {
        const response = await $api.get(`/attachments/files?attachmentId=${encodeURIComponent(attachmentId)}`, {
            responseType: 'blob'
        });

        const contentType = response.headers['content-type'];
        const contentDisposition = response.headers['content-disposition'];
        
        let filename = contentDisposition?.match(/filename="?(.+)"?/)?.[1];
        
        if (!filename || filename === 'undefined') {
            const extension = getExtensionFromContentType(contentType);
            filename = `image_${attachmentId}.${extension}`;
        }

        if (!filename.match(/\.[a-z0-9]+$/i)) {
            const extension = getExtensionFromContentType(contentType);
            filename += `.${extension}`;
        }

        console.log('Final filename:', filename);

        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `image_${attachmentId}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        return true;
    } catch (error) {
        console.error('Ошибка при скачивании файла:', error);
        return false;
    }
};

const getExtensionFromContentType = (contentType: string): string => {
    const extensionMap: { [key: string]: string } = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
    };
    return extensionMap[contentType] || 'png';
};

export const uploadImageAttachments = async (files: FileList): Promise<string[]> => {
    const ids: string[] = [];
    const step = async (i: number): Promise<void> => {
        const file = files[i];
        if (!file) return;
        if (!file.type.includes("image")) {
            await step(i + 1);
            return;
        }
        const fd = new FormData();
        fd.set("file", file);
        const res = await $api.post<{ id: string }>("/attachments/files/upload", fd);
        if (res?.data?.id) ids.push(res.data.id);
        await step(i + 1);
    };
    await step(0);
    return ids;
};
